// The backend, Recurly (Account.vatNumber) and orders.abn all carry a single tax
// number under the `abn` key. The form collects it under a country-specific field:
// ABN (AU), NZBN (NZ) or the generic Tax ID / VAT / GST Number (international,
// BUSREQ-14451). Only one is ever visible for a given country.
export const getTaxIdentifier = values =>
  values?.abn || values?.nzbn || values?.taxId || ''
